<style lang='less'>
@import '../../../../stylesheet/variable.less';
  .delivery-info {
    background-color:rgb(244,244,244);
    .delivery-header{
      background-color:white;
      padding: 12px 15px;
      font-size: 13px;
      line-height:20px;
      color: rgb(19,20,21);
      margin-bottom:10px;
      label{
        color: rgb(121,125, 130);
        margin-right: 7px;
      }
      .common {
        margin-bottom: 3px;
      }
    }
    .delivery-detail{
       background-color:white;
       position:relative;
       .delivery-cover-line-top{
         position:absolute;
         width:6px;
         height:36px;
         top:0px;
         left: 64px;
         background-color:white;
       }
       .delivery-cover-line-bottom{
         position:absolute;
         width:6px;
         height:36px;
         bottom:0px;
         left: 64px;
         background-color:white;
       }
       .delivery-item{
          height:80px;
          font-size:12px;
          display: flex;
          align-items: center;
          .delivery-timeAndDate{
            min-width: 66px;
            text-align: center;
            padding: 21px 0;
            color:rgb(121,125,130);
            display:inline-block;
            box-sizing:border-box;
            border-right: 1px solid rgb(210, 214, 220);
            margin-right: -4px;
            height:100%;
            .delivery-time {
              font-size: 13px;
            }
            .delivery-date{
              font-size:10px;
            }
          }
          .delivery-fristItem-timeAndDate{
            min-width: 66px;
            text-align: center;
            padding: 21px 0;
            color:rgb(25, 26, 27);
            display:inline-block;
            box-sizing:border-box;
            margin-right: -8px;
            border-right: 1px solid rgb(210, 214, 220);
            height:100%;
            .delivery-time {
              font-size: 13px;
            }
            .delivery-date{
              font-size:10px;
            }
          }
          .delivery-icon{
            z-index:100;
            height:7.5px;
            min-width:7.5px;
            border-radius:4px;
            background-color:rgb(210,214,220);
          }
          .delivery-fristItem-icon{
            z-index:100;
            display: flex;
            justify-content: center;
            align-items: center;
            height:15px;
            min-width:15px;
            border-radius:8px;
            background-color:rgba(192,49,49,0.2);
            position: relative;
            &:after {
              content: '';
              height: 9px;
              width: 9px;
              border-radius:5px;
              background-color:rgb(192, 49, 49);
            }
          }
          .delivery-message{
            width: calc(~'100% - 73.5px');
            padding: 21px 15px 21px 0;
            margin-left: 15px;
            color:rgb(121,125,130);
            box-sizing:border-box;
            height:100%;
            display:inline-block;
            display: flex;
            justify-content:flex-start;
            align-items: center;
            position: relative;
            &:before {
              .setTopLine()
            }
          }
          .delivery-fristItem-message{
            width: calc(~'100% - 73.5px');
            padding: 21px 15px 21px 0;
            margin-left: 15px;
            color:rgb(25, 26, 27);
            box-sizing:border-box;
            height:100%;
            display:inline-block;
            display: flex;
            justify-content:flex-start;
            align-items: center;
          }
       }
    }
    a, a:hover, a:focus {
      color: #5F7DEC
    }
  }
</style>
<template>
<div>
  <div class="delivery-info" v-if="showView">
    <div class="delivery-header">
      <div class="delivery-header-company common">
        <label>快递公司</label>
        {{header.expressCompanyName}}
      </div>
      <div class="delivery-header-orderId common">
        <label>快递单号</label>
        {{header.expressId | getOrder}}
      </div>
      <div class="delivery-header-phone common">
        <label>客服电话</label>
        <a :href="`tel://${header.phone}`">{{header.phone}}</a>
      </div>
    </div>
    <div class="delivery-detail" >
        <div class="delivery-item" v-for="(logistic,index) in list">
          <div v-bind:class="index==0?'delivery-fristItem-timeAndDate':'delivery-timeAndDate'">
            <div class="delivery-time">{{logistic.acceptTime | getTime}}</div>
            <div class="delivery-date">{{logistic.acceptTime | getDate}}</div>
          </div>
          <div v-bind:class="index==0?'delivery-fristItem-icon':'delivery-icon'"></div>
          <div v-bind:class="index==0?'delivery-fristItem-message':'delivery-message'"><p v-html="highLight(logistic.acceptStation)"></p></div>
        </div>
        <div class="delivery-cover-line-top"></div>
        <div class="delivery-cover-line-bottom"></div>
    </div>
  </div>
  
  <dp v-if="errorLogistics" :imgUrl="errImg" :text="errText"/>
</div>
  
</template>

<script>
  import setDocumentTitle from '../../../util/document-title'
  import _ from 'underscore'
  import {mapState} from 'vuex'
  import op from 'object-path'
  import Defaultpage from '../../../components/default-page.vue'
  const app = {
    data() {
      return {
        serviceId: this.$route.query.serviceId,
        orderId: this.$route.params.orderId,
        expressId: this.$route.query.id,
        expressCompanyId: this.$route.query.company,
        showView: false,
        errorLogistics: false,
        errText: '',
        errImg: require('../../../../image/order/rectangleCopy19@2x.png')
      }
    },
    components: {
      'dp': Defaultpage,
    },
    computed: {
      ...mapState({
        header: state => op(state.order.deliveryInfo).get('express'),
        traceList: state => op(state.order.deliveryInfo).get('traceList') || []
      }),
      list() {
        return _.chain(this.traceList).extend().reverse().value()
      }
    },
    mounted () {
      let data = {
        orderId: this.orderId
      }
      if(this.expressId || this.expressCompanyId) {
        data.expressId = this.expressId
        data.expressCompanyId = this.expressCompanyId
      }
      if(this.serviceId) {
        data.serviceId = this.serviceId
        delete data.orderId
      }
      this.$store.dispatch('getDeliveryInfo', data).then(res => {
        this.showView = true
      }).catch(e => {        
        this.errorLogistics = true
        this.errText = e.message || '系统异常'
      })
      setDocumentTitle('物流信息')

    },
    filters: {
      getDate(value) {
        if(value) {
          return value.split(" ")[0].substr(5)
        }
        return value
      },
      getTime(value) {
        if(value){
          return value.split(" ")[1].substr(0, 5)
        }
        return value
      },
      getOrder(value) {
        return value.replace(/(\d{4})(?=\d)/g,"$1 ")
      }
    },
    methods: {
      highLight(value) {
        const reg = /((((13[0-9])|(15[^4])|(18[0,1,2,3,5-9])|(17[0-8])|(147))\d{8})|((\d3,4|\d{3,4}-|\s)?\d{7,14}))?/g
        let matchArr = value.match(reg)
        let newArray = _.chain(matchArr).filter((num) => {return num != ""}).uniq().value()
        if(newArray.length > 0) {
          for(let i=0;i < newArray.length;i++) {
            value = value.replace(newArray[i], `<a href='tel://${newArray[i]}'>${newArray[i]}</a>`)
          }
        }
        return value
      }
    }
  }
  export default app
</script>

